import React from "react";
import { Modal, Button, Table } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { TestAttempt } from "../../stores/TestsStore";
import { useStore } from "../../stores/root-store-context";

interface AttemptModalProps {
    visible: boolean;
    onClose: () => void;
    attempts: TestAttempt[];
}

export const TestAttemptModal: React.FC<AttemptModalProps> = ({ visible, onClose, attempts }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { applicationStore, testsStore } = useStore();

    const columns = [
        {
            title: t("tests.attemptNumber"),
            dataIndex: "numberAttempt",
            key: "numberAttempt",
        },
        {
            title: t("tests.grade"),
            dataIndex: "percentage",
            key: "percentage",
            render: (value: number) => `${value}/100%`
        },
        {
            title: t("tests.testName"),
            dataIndex: "testId",
            key: "testId",
            render: (testId: number) => {
                var existTest = testsStore.testsPublic.find(t => t.id == testId);

                if(existTest){
                    return existTest.name;
                }
                else{
                    var existTestName = testsStore.testsCompany.find(t => t.id == testId)?.name ?? "no found!";

                    return existTestName;
                }
            },
        },
        {
            title: t("Start Date"),
            dataIndex: "startDate",
            key: "startDate",
            render: (value: string) =>
                value
                    ? new Date(value).toLocaleString('uk-UA', {
                        day: 'numeric',
                        month: 'numeric',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                    }).replace(/,/g, '')
                    : t("No date"),
        },
        {
            title: t("tests.finishDate"),
            dataIndex: "finishDate",
            key: "finishDate",
            render: (value: string) =>
                value
                    ? new Date(value).toLocaleString('uk-UA', {
                        day: 'numeric',
                        month: 'numeric',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                    }).replace(/,/g, '')
                    : t("No date"),
        },
        {
            title: `${t("tests.timeSpent")} (${t("passage_test.minutes")})`,
            dataIndex: "timeSpentMinutes",
            key: "timeSpentMinutes",
        },
        {
            title: t("Actions"),
            key: "actions",
            render: (record: TestAttempt) => (
                <a
                    onClick={() => navigate(`/${applicationStore.company.Tenant}/tests/result/${record.id}`)}
                >
                    <EyeOutlined />
                </a>
            ),
        },
    ];

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={[
                <Button key="close" onClick={onClose}>
                    {t("tests.Close")}
                </Button>,
            ]}
            width={800}
            style={{ maxWidth: "90%", top: 20 }}
        >
            {attempts.length > 0 ? (
                <Table dataSource={attempts} rowKey="id" pagination={false} columns={columns} />
            ) : (
                <p>{t("No attempts available.")}</p>
            )}
        </Modal>
    );
}